module.exports = __webpack_public_path__ + "img/30-Starting to thin.08b59ebd.png";